import { AT } from '../../../actions/actionTypes';
import {
  getStateFull,
  doAction,
  doEmptyAction,
} from '../../../core/redux/store';
import { Groups, FeedbackAddPL, SelectMode } from '../../../models';

import { State, FileTypes, InitPL, SetItemsPL, SetModePL } from './model';
import { isValidKemPassword, getMode } from './utils';
import {
  msgNotImplemented,
  msgDownloadSuccess,
  msgSigFoxError,
  msgDownloadError,
  msgOnlyDevicesOneCustomerError,
  msgDownloadPartialWarning,
} from './messages';
import { Panels } from '../model';
import { setRightPanel } from '../actions';
import * as Devices from '../../devices';
import * as Orders from '../../orders';
import * as DTypes from '../../devicetypes';
import * as Customers from '../../customers';
import * as MyKeysApiDownload from '../../../core/apis/mykeys/download';

import {
  ErrorDataResponse,
  ErrorDataResponseDefault,
  ReasonPhrases,
  ServerFaults,
} from '../../../core/apis/mykeys/exceptions';
import {
  CriteriaListDto,
  CriteriaListDtoDefault,
  IDownloadableCheck,
  IDownloadableFile,
  MyKeysPromise,
} from '../../../interfaces';
import { downloadFile } from '../../../utils';
import { MyKeysPromiseMap } from '../../../core/apis/mykeys/mappings';
import { LMessage, MessageType } from '../../../core/localization';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';

const getState = (): State => getStateFull().dialogState.downloadState;

export const openDialog = () => setRightPanel(Panels.DEVICE_DOWNLOAD);
export const initDialog = (groupedBy = Groups.DEVICES, keys: string[] = []) => {
  Logger.info(['initDialog', keys, groupedBy], LogArea.Redux);
  const mode = getMode(groupedBy, keys);
  const payload = { groupedBy, mode, keys } as InitPL;
  doAction<InitPL>(AT.DIALOG_DOWNLOAD_INIT, payload);
  openDialog();
};

export const setItems = (keys: string[] = []) => {
  Logger.info(['setItems', keys], LogArea.Redux);
  const payload = { keys } as SetItemsPL;
  doAction<SetItemsPL>(AT.DIALOG_DOWNLOAD_SETITEMS, payload);
};

export const setMode = (groupedBy = Groups.DEVICES, mode: SelectMode) => {
  Logger.info(['setMode', mode], LogArea.Redux);
  const payload = { groupedBy, mode } as SetModePL;
  doAction<SetModePL>(AT.DIALOG_DOWNLOAD_SETMODE, payload);
};

const donwloadTypeNotImplemented = (downloadType: string) => {
  const notImplMessage = msgNotImplemented(downloadType);
  doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_ERROR, { content: [notImplMessage] });
};

const downloadAllFilesSuccess = (data: IDownloadableFile[]) => {
  data.forEach((file) => downloadFile(file));
  const successMessage = msgDownloadSuccess(data.length);
  doEmptyAction(AT.DIALOG_DOWNLOAD_SUCCESS);
  doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_SUCCESS, {
    content: [successMessage],
  });
};

const handleDownloadAllFilesError = (downloadType: string) => (
  err: ErrorDataResponse = ErrorDataResponseDefault
) => {
  const messages: LMessage[] = [];
  if (
    downloadType === FileTypes.SIGFOX &&
    err.title === ReasonPhrases.ServerFaults &&
    err.detail.startsWith(ServerFaults.NoDevicesMeetsCriteriaException)
  )
    messages.push(msgSigFoxError);
  else if (
    err.title === ReasonPhrases.ServerFaults &&
    err.detail.startsWith(ServerFaults.OnlyDevicesForOneCustomerIsAllowedException)
  )
    messages.push(msgOnlyDevicesOneCustomerError);
  else messages.push(msgDownloadError(downloadType));

  doEmptyAction(AT.DIALOG_DOWNLOAD_ERROR);
  doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_ERROR, { content: messages });
};

const showWarning = (msg: LMessage) => {
  const messages: MessageType[] = [msg];
  doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_WARNING, {
    content: messages,
  });
}

const handleDonwloadCheck = (
  succeedPromise: MyKeysPromise<IDownloadableFile>
) => (res: IDownloadableCheck) => {
  if (res.invalidDevices.length > 0) {
    if (res.numDevicesInKem === 0) return Promise.reject();
    else showWarning(msgDownloadPartialWarning);
  }
  return succeedPromise;
};

export const download = (downloadType: string, password = '') => {
  const state = getState();
  if (state.isFetching) return;

  let criteria: CriteriaListDto = CriteriaListDtoDefault;
  let totals = Devices.TotalsByTypeDefault;
  let deviceIds: Devices.PKey[] = [];
  let labels: string[] = Devices.getDevicesLabelsFilter();

  switch (state.groupedBy) {
    case Groups.DEVICES:
      const isDownloadAll = (state.mode === SelectMode.All);
      const dkeys = isDownloadAll ? [] : state.keys;
      criteria = Devices.getCriteria();      
      totals = Devices.getTotals(dkeys);
      deviceIds = isDownloadAll ? Devices.getDevicesSNFilter() : Devices.parseKeys(dkeys);
      break;
    case Groups.ORDERS:
      criteria = Orders.getCriteria(state.keys);
      totals = Orders.getTotals(state.keys);
      break;
    case Groups.DEVICETYPES:
      criteria = DTypes.getCriteria(state.keys);
      totals = DTypes.getTotals(state.keys);
      break;
    case Groups.CUSTOMERS:
      criteria = Customers.getCriteria(state.keys);
      totals = Customers.getTotals(state.keys);
      break;
    default:
      break;
  }

  const filesToRequest = [];
  switch (downloadType) {
    case FileTypes.CSV:
      filesToRequest.push(MyKeysApiDownload.downloadCSV(criteria, deviceIds, labels));
      break;
    /*case FileTypes.XML:
      Devices.numMetersDevices(totals) > 0 &&
        filesToRequest.push(
          MyKeysApiDownload.downloadXML(criteria, deviceIds, false)
        );
      Devices.numNoMetersDevices(totals) > 0 &&
        filesToRequest.push(
          MyKeysApiDownload.downloadXML(criteria, deviceIds, true)
        );
      break;
    case FileTypes.OMS:
      Devices.numMetersDevices(totals) > 0 &&
        filesToRequest.push(
          MyKeysApiDownload.downloadOMS(criteria, deviceIds, false)
        );
      Devices.numNoMetersDevices(totals) > 0 &&
        filesToRequest.push(
          MyKeysApiDownload.downloadOMS(criteria, deviceIds, true)
        );
      break;*/
    case FileTypes.KEM:
      if (!isValidKemPassword(password)) return;


      Devices.numMetersDevices(totals) > 0 &&
        filesToRequest.push(
          MyKeysApiDownload.verifyKEM(criteria, deviceIds, labels, false, password)
            .then(MyKeysPromiseMap)
            .then(handleDonwloadCheck(MyKeysApiDownload.downloadKEM(criteria, deviceIds, labels, false, password)))
        );
      Devices.numNoMetersDevices(totals) > 0 &&
        filesToRequest.push(
          MyKeysApiDownload.verifyKEM(criteria, deviceIds, labels, true, password)
            .then(MyKeysPromiseMap)
            .then(handleDonwloadCheck(MyKeysApiDownload.downloadKEM(criteria, deviceIds, labels, true, password)))
        );
      break;
    case FileTypes.KEM2:
      if (!isValidKemPassword(password)) return;
      filesToRequest.push(
        MyKeysApiDownload.verifyKEM2(criteria, deviceIds, labels, password)
        .then(MyKeysPromiseMap)
        .then(handleDonwloadCheck(MyKeysApiDownload.downloadKEM2(criteria, deviceIds, labels, password)))
      );
      break;
    case FileTypes.SIGFOX:
      filesToRequest.push(
        MyKeysApiDownload.downloadSigFox(criteria, deviceIds, labels)
      );
      break;
    default:
      break;
  }

  if (filesToRequest.length === 0) {
    donwloadTypeNotImplemented(downloadType);
    return;
  }

  Promise.all(filesToRequest)
    .then((x) => x.map(MyKeysPromiseMap))
    .then(downloadAllFilesSuccess)
    .catch(handleDownloadAllFilesError(downloadType));

  doEmptyAction(AT.DIALOG_DOWNLOAD_FETCH);
};
